<template>
  <div style="width:99%" >
    <div class="m-b-20 m-t-20" >
      <el-card class="box-card title" shadow="never">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <!-- 我的主页 -->
          <el-breadcrumb-item :to="{ path: '/insp/index' }">{{$t('user_Index_WDZY')}}</el-breadcrumb-item>
          <!-- 申请记录 -->
          <el-breadcrumb-item>{{$t('user_Index_SQJL')}}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-card>      
    </div> 
    <!-- 表格 -->
    <el-row  class="bg-grey p-15 fs-12 border" :gutter="10" style="margin-right:0px;margin-left:0px;">
      <!-- 验货类型 -->
      <el-col :span="3">
        <span>{{$t('user_Index_YHLX')}}</span>
      </el-col>
      <!-- 产品名称 -->
      <el-col :span="4">
        <span>{{$t('user_Index_CPMC')}}</span>
      </el-col>
      <!-- 验货地址 -->
      <el-col :span="5">
        <span>{{$t('user_Index_YHDZ')}}</span>
      </el-col>
      <!-- 申请日期 -->
      <el-col :span="3">
        <span>{{$t('user_Index_SARQ')}}</span>
      </el-col>
      <!-- 验货人数 -->
      <el-col :span="2" class="text-center">
        <span>{{$t('user_Index_YHRS')}}</span>
      </el-col>
      <!-- 验货时长 -->
      <el-col :span="3" class="text-center">
        <span>{{$t('user_Index_YHSC')}}</span>
      </el-col>
      <!-- 审核状态 -->
      <el-col :span="2">
        <span>{{$t('user_Index_SHZT')}}</span>
      </el-col>
      <!-- 操作 -->
      <el-col :span="2">
        <span>{{$t('user_Index_CAOZUO')}}</span>
      </el-col>
    </el-row>
    <div class="border p-15 text-center fs-12 text-grey" v-if="page_total==0">
      <span>{{$t('user_Index_NODATA')}}</span>
    </div>
    <div v-else class="border p-h-5" v-for="(ta,index) in tableData" :key="index">
      <!-- 下单日期和订单号 -->
      <div class="p-10 fs-12 b-b">
        <span>{{$t('user_Index_YHSJ') + ta.orders.inspect_time}}</span>
       
        <!-- <span class="m-l-30"  >{{$t('user_Index_DDH')}}：{{ta.orders.orders_num}}</span> -->
       
        <router-link v-if="ta.status==2" tag="a" class="m-l-30 text-blue"  target="_blank" :to="{path:'orderManage/orderDetail',query:{id:ta.orders_id}}">{{ta.orders.orders_num}}</router-link>
        <span class="m-l-30 text-blue" v-else>{{ta.orders.orders_num}}</span>
       
        <template>
            <span v-if="ta.status==1" class="text-yellow m-l-30">{{$t('user_Index_SHZDDD')}}</span>
            <span v-else-if="ta.status==2" class="text-yellow m-l-30">{{$t('user_Index_SQCG')}}</span>
            <span v-else  class="text-yellow m-l-30">{{$t('user_Index_XCHZ')}}</span>
        </template>
      </div>
      <el-row class="p-15 fs-12 lh-28" :gutter="10">
        <!-- 验货类型 -->
        <el-col :span="3">
          <template>
            {{ta.orders.type==1?$t('Home_index_cj'):ta.orders.type==2?$t('Home_index_qj'):ta.orders.type==3?$t('Home_index_zxjy'):ta.orders.type==4?$t('Home_index_yc'):ta.orders.type==5?$t('Home_index_jg'):$t('Home_index_yzAndjg')}}
          </template>
        </el-col>
        <!-- 产品名称 -->
        <el-col :span="4">
          <template>
            <span v-for="(item,index) in ta.orders.products" :key="index">
              <!-- {{index!==ta.orders.products.length-1? item.product_name+',':item.product_name}} -->
              {{index!==ta.orders.products.length-1? item.product_name?item.product_name:'N/A'+',':item.product_name?item.product_name:'N/A'}}
            </span>
            <span v-if="ta.orders.products.length==0">N/A</span>
          </template>
        </el-col>
        <!-- 验货地址 -->
        <el-col :span="5">
          <template>
            {{ta.orders.country+ta.orders.province+ta.orders.city+ta.orders.insp_address}}
          </template>
        </el-col>
        <!-- 申请日期 -->
        <el-col :span="3">
          <template>
            {{ta.create_at}}
          </template>
        </el-col>
        <!-- 验货人数 -->
        <el-col :span="2" class="text-center">
          <template>
            {{ta.orders.insp_number}}
          </template>
        </el-col>
        <!-- 验货时长 -->
        <el-col :span="3" class="text-center">
          <template>
            {{ta.orders.insp_day}}
          </template>
        </el-col>
        <!-- 审核状态 -->
        <el-col :span="2" class="relative">
          <template>
            <div v-if="ta.status==1">
              <!-- 审核中 -->
              <span style="opacity:0;">{{$t('user_Index_SHZ')}}</span>
              <img src="../../../assets/images/imgon.png" class="absolute" style="left:-35px;top:-30px;" height="70px">
            </div>
            <div v-else-if="ta.status==2">   
              <!-- 审核通过            -->
              <span style="opacity:0;">{{$t('user_Index_SHTG')}}</span>
              <img src="../../../assets/images/imgyes.png" class="absolute" style="left:-35px;top:-30px;" height="70px">
            </div>
            <div v-else>              
              <span style="opacity:0;" class='m-10'></span>
              <img src="../../../assets/images/imgnext.png" class="absolute" style="left:-35px;top:-30px;" height="70px">
            </div>
          </template>
        </el-col>
        <!-- 操作 -->
        <el-col :span="2">
          <template>
            <el-button type='primary' :disabled="ta.status!=1" size='mini' @click="quxiao(ta.orders_id)">{{$t('quxiaoShengqing')}}</el-button>
          </template>
        </el-col>
      </el-row>
    </div>
<!--     <el-pagination
        class="m-20 text-right"
        :page-size="page_size"
        :page-sizes="page_size_opts"
        :total="page_total"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="page_current"
        @current-change="pageChange"
        @size-change="pageSizeChange"></el-pagination>  -->
            <Pagination
                    :total="page_total"
                    :pageSize.sync="page_size"
                    :currentPage.sync="page_current"
                    @getData="getTableData"
                  ></Pagination>
    <!-- 失败 -->
    <el-dialog v-dialogDrag :title="$t('user_Index_SHSB1')"  v-if="fileVis" :visible.sync="fileVis" width="300px">
      <div>
        <span>{{$t('user_Index_BQTZ')}}</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="fileVis=false" type="primary" class="button-radius-5px">{{$t('user_Index_CLOSE')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { app_record,withdraw} from "@/Inspector_api/index";
export default {
  data() {
    return {
      tableData:[],
      fileVis:false,
    };
  },
  methods: {
    //获取用户信息
    async getTableData() { 
      let list={
        page:this.page_current,
        page_size:this.page_size
      }     
      const res = await app_record(list);
      const { code, data } = res.data;
      if (code == 200) {
        this.tableData = data.list?data.list:[];
        this.page_total=data.total_num
      }
    }, 
    //取消订单
    quxiao(id){
       this.$confirm(this.$t('user_Index_QXDD'))
          .then(_ => {
            this.cancel(id)
          }).catch(_ => {});
    },
    //取消订单
    async cancel(id){
      const res = await withdraw({order_id:id});
      const { code, data,msg } = res.data;
      if (code == 200) {
        this.$message.success(msg)
        this.getTableData()
      }else{
        this.$message.error(msg)
      }
    }
  },
  created() {
    this.getTableData()
  }
};
</script>


<style lang="scss" scoped>
.title /deep/ .el-card__body{
  padding: 12px;
}
/deep/ .el-dialog__header{
  height: 45px !important;
}
</style>